module.exports = __webpack_public_path__ + "static/img/sociedad_civil.4f2d9c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sociedad_civil.jpg
// module id = CgmV
// module chunks = 9